import { defineStore } from "pinia";

export const cartStore = defineStore("cart", {
  state: () => ({
    cart: [],
    customerInfo: {}
  }),
  actions: {
    setCustomerInfo(customer) {
      localStorage.setItem("customer_data", JSON.stringify(customer));
      this.customerInfo = Object.assign({}, customer);
    },

    loadCustomerInfo() {
      const customer = JSON.parse(localStorage.getItem("customer_data"));
      if (customer) {
        this.customerInfo = Object.assign({}, customer);
      }
    },

    setCart(cart) {
      localStorage.setItem("cart", JSON.stringify(cart));
      this.cart = cart;
    },

    save(){
      this.setCart(this.cart);
      this.setCustomerInfo(this.customerInfo);
    },

    loadCart() {
      const cart = JSON.parse(localStorage.getItem("cart"));
      if (cart) {
        this.cart = cart;
      }
    },

    removeCart() {
      localStorage.removeItem("cart");
      this.cart = [];
    },

    removeCustomerInfo() {
      localStorage.removeItem("customer_data");
      this.customerInfo = {};
    },

    load(){
      this.loadCart();
      this.loadCustomerInfo();
    }
  },
});
